import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 2,
        colsSize: [1, 3],
        rowsSize: [1, 2],
        gap: "24px",
        components: [
          [],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/14/principle/info-icon.svg`,
                    styles: {
                      width: "32px",
                      height: "32px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  justifyContent: "flex-end",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data:
                      "The Hearing Model of Sottek (HMS) replicates human hearing by using filters that perform similar functions to that of our outer and middle ear, and basillar membrane. It also performs the compressive nonlinearity required for loudness perception. This model can be used to calculate different psychoacoustic parameters.",
                    scrollbars: false,
                    styles: {
                      textAlign: "left",
                      width: "370px",
                      padding: 0,
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
